import React from 'react';
export function SmartAskAmountsInfo() {
  return <div className="bg-[#EFF6FF] border border-[#0047AB]/20 rounded-lg p-4 mt-4" data-id="element-294">
      <div className="flex items-start gap-3" data-id="element-295">
        <div className="flex-shrink-0 w-5 h-5 bg-[#0047AB] rounded-full flex items-center justify-center mt-0.5" data-id="element-296">
          <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-297">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-298" />
          </svg>
        </div>
        <div className="flex-1" data-id="element-299">
          <h4 className="text-sm font-semibold text-gray-900 mb-2" data-id="element-300">
            To unlock Smart Ask Amounts and Smart Segments, please upload 5 full
            years of Giving History.
          </h4>
          <div className="text-sm text-gray-700" data-id="element-301">
            <p className="font-medium mb-2" data-id="element-302">Requirements:</p>
            <ul className="space-y-1 ml-4" data-id="element-303">
              <li className="flex items-start" data-id="element-304">
                <span className="font-medium mr-2" data-id="element-305">Total Span:</span>
                <span data-id="element-306">
                  There must be a full 5-year difference between the date of
                  your oldest gift and your most recent gift.
                </span>
              </li>
              <li className="flex items-start" data-id="element-307">
                <span className="font-medium mr-2" data-id="element-308">Continuity:</span>
                <span data-id="element-309">
                  You must have at least one gift recorded in every single year.
                </span>
              </li>
              <li className="flex items-start" data-id="element-310">
                <span className="font-medium mr-2" data-id="element-311">Freshness:</span>
                <span data-id="element-312">
                  Your data must be current. If no gifts are present from the
                  last 6 months, these features will be locked.
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>;
}